import React, { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import NavBar from './Layout/NavBar';
import SideBar from './Layout/SideBar';

export default function HomeDashboard() {
  const navigate = useNavigate();

  // const userLogin = useSelector((state) => state.userLogin);
  // const { userInfo } = userLogin;

  useEffect(() => {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (!userInfo || !userInfo.isAdmin) {
      navigate('./login');
    }
  }, []);

  return (
    <>
      <NavBar />
      <div className="container-fluid page-body-wrapper">
        {' '}
        <SideBar />
        <div className="main-panel">
          {' '}
          <div className="content-wrapper">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
